<template>
    <modal @close="clearSelectedPerson" dialog="modal-lg" class="dark-top" :footer="false">
        <div slot="title">
            <h2>Agent details</h2>
            <h3 v-if="getSelectedPerson">{{ getSelectedPerson.brandName }}</h3>
        </div>

        <div slot="body">


            <tabs>
                <!--<tab name="Overview">
                    <overview></overview>
                </tab> -->
                <tab name="DETAILS">
                    <agent-edit :showButtons="false" :agent="tempSelectedPerson"></agent-edit>
                </tab>
                <tab name="COMMISSIONS">
                    <commissions :showButtons="false" :passedForm="tempSelectedPerson"></commissions>
                </tab>
                <tab name="ADVANCED SETTINGS" v-if="showOtaAdvancedSettingsTab">
                    <ota-settings :agent="tempSelectedPerson" :otaChannelType="tempSelectedPerson.channelType"></ota-settings>
                </tab>
            </tabs>

            <div class="d-flex justify-content-end align-items-center mb-4 p-3">
                <button class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                <button class="btn green wider" @click="save">Save</button>
            </div>

        </div>
    </modal>
</template>

<script>

    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import Empty from '../Empty'
    import AgentEdit from '@/components/people/agents/AgentEdit'
    import Overview from '@/components/people/agents/AgentOverview'
    import Commissions from '@/components/people/agents/AgentCommissionsWrapper'
    import OtaSettings from '@/components/people/agents/AgentOtaSettings'

    import mixpanelMixin from '@/mixins/mixpanel'

    export default {
        mixins: [
            mixpanelMixin
        ],
        data: function () {
            return {
                tempSelectedPerson: null,
            }
        },
        created: function() {
            // this.getAgentCommissions()
            this.tempSelectedPerson = JSON.parse(JSON.stringify(this.getSelectedPerson))

        },
        computed: {
            ...mapGetters([
                'getSelectedPerson',
                'account'
            ]),
            showOtaAdvancedSettingsTab: function () {
                let otasWithoutAdvancedSettings = [201]

                if(!this.tempSelectedPerson || !this.tempSelectedPerson.isOTA || otasWithoutAdvancedSettings.includes(this.tempSelectedPerson.channelType)){
                    return false
                } else {
                    return true
                }
            },
        },
        methods: {
            ...mapActions([
                'clearSelectedPerson',
                'updateClonedAgent',
                'updateNewAgentSetup',
                'closeModal',
                'updateAgent',
                'getOtaAgentInfo',
                'updateOtaAgentInfo',
                'getOTAByChannelType'
            ]),
            getAgentCommissions: function() {
                axios.get('/api/people/GetAgentCommissions', {
                    params: {
                        supplierId: this.account.supplierId,
                        agentId: this.getSelectedPerson.id
                    }
                }).then(response => {
                    if (response && response.status === 200 && response.data) {
                        // this.form.commission = response.data;
                        this.$set(this.getSelectedPerson, 'commission', response.data)
                    }
                })
            },
            cancel: function() {
                this.closeModal();
            },
            save: function() {
                //if is OTA we use a different save method

                // this.tempSelectedPerson = JSON.parse(JSON.stringify(this.getSelectedPerson))
                this.updateNewAgentSetup(this.tempSelectedPerson); //in case there is an error it has data to populate the new agent form
                this.updateClonedAgent(this.tempSelectedPerson);


                this.updateAgent({
                    agent: this.tempSelectedPerson
                });

                this.trackSaveChanges('Agent', this.tempSelectedPerson.id, this.tempSelectedPerson.brandName)
            }
        },
        components: {
            Modal,
            Empty,
            AgentEdit,
            Overview,
            Commissions,
            OtaSettings
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .tabs-component-tabs {
        margin: 0 1.5rem;
    }
</style>



// WEBPACK FOOTER //
// AgentView.vue?45e18e58